/*eslint-disable*/
import React, {useState, useContext, useEffect} from "react";
import {mainContext} from 'reducer'
import TronLinkClient from "WalletClient/TronlinkClient.js";
import {t} from "utils/text.js";
import Emitter from "utils/eventBus";
import {claim, getTokenID, getTXStatus, getBonus} from "service.js";
import {RANKENUM, CONTRACT, TRONSCAN} from "constants.js";

let interval = null;

export default function Draw() {

    const {state, dispatch} = useContext(mainContext);
    const {account, tronAddress} = state;
    const [random, setRandom] = useState(0);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [halfDone, setHalfDone] = useState(false);
    const [tokenID, setTokenID] = useState(0);
    const [hash, setHash] = useState(null);
    const [hit, setHit] = useState(false);
    const [amount, setAmount] = useState(0);

    useEffect(() => {
        setDone(false)
    }, [tronAddress])

    const animation = () => {
        interval = setInterval(() => {
            setRandom(Math.floor(Math.random() * 10 + 1));
        }, 500);
    };

    const draw = async () => {

        if (!TronLinkClient.isInstalled) {
            Emitter.emit("openMessageModal", {message: 'TRONLINK not Installed'});
            return;
        }
        if (!TronLinkClient.isLogin) {
            Emitter.emit("openMessageModal", {message: 'TRONLINK not Login'});
            return;
        }
        setLoading(true);
        setHalfDone(false);
        setDone(false);
        animation();

        let result = await claim(account.rank, account.signature);

        if (result && result['error']) {
            setLoading(false);
            setDone(false);
            setRandom(0);
            clearInterval(interval);
            Emitter.emit("openErrorModal", {message: result.message});
        } else {
            setTimeout(async () => {
                let verify_hash = await getTXStatus(result);
                if (verify_hash === 'SUCCESS') {
                    let token_id = await getTokenID(result);
                    if (token_id) {
                        setTokenID(token_id);
                        setRandom(100);
                        setDone(true);
                    } else {
                        setHash(result);
                        setRandom(0);
                        setHalfDone(true);
                    }
                    let {hit, amount} = await getBonus();
                    setHit(hit);
                    setAmount(amount);
                    

                    dispatch({
                        type: 'SET_NFT',
                        nft: {
                            tokenId: token_id,
                            amount,
                            level: account.rank
                        }
                    });
                } else {
                    setRandom(0);
                    Emitter.emit("openErrorModal", {message: 'fail_to_claim'});
                }

                clearInterval(interval);
                setLoading(false);

            }, 6000);

        }

    };

    return (
        <>
            <div className="container mx-auto h-full">
                <div className="w-full text-center h-full flex flex-col justify-center items-center">
                    <div
                        // className={'title ' + (done ? ' invisible' : ' visible')}>{t('section_6_title_1')} '<strong>{t(RANKENUM[account.rank])}</strong>' {t('section_6_title_2')}
                        className={'title ' + (done ? ' invisible' : ' visible')}>{t('section_6_title_1')}
                        '
                        {account.randomLevels.map((item, index) => 
                            <strong key={item}>{t(RANKENUM[item])}{index !== account.randomLevels.length - 1 ? '/' : ''}</strong>
                        )}
                        ' {t('section_6_title_2')}
                    </div>
                    <div className='flex justify-center'>
                        <div className='flex flex-col justify-between items-center'>

                            <div className='img_div'>
                                {(random === 0 && !done) && <img src={require('../assets/img/default.png').default}/>}
                                {(random === 1 && !done) && <img src={require('../assets/img/NFT_1.png').default}/>}
                                {(random === 2 && !done) && <img src={require('../assets/img/NFT_2.png').default}/>}
                                {(random === 3 && !done) && <img src={require('../assets/img/NFT_3.png').default}/>}
                                {(random === 4 && !done) && <img src={require('../assets/img/NFT_4.png').default}/>}
                                {(random === 5 && !done) && <img src={require('../assets/img/NFT_5.png').default}/>}
                                {(random === 6 && !done) && <img src={require('../assets/img/NFT_6.png').default}/>}
                                {(random === 7 && !done) && <img src={require('../assets/img/NFT_7.png').default}/>}
                                {(random === 8 && !done) && <img src={require('../assets/img/NFT_8.png').default}/>}
                                {(random === 9 && !done) && <img src={require('../assets/img/NFT_8.png').default}/>}
                                {(random === 10 && !done) && <img src={require('../assets/img/NFT_8.png').default}/>}

                                {done && <img
                                    src={'https://dist.apenft.io/genesis_images/' + tokenID + '.png'}/>}
                            </div>
                            {
                                done &&
                                <div className='mt-6 flex flex-col items-center'>
                                    <p className='p1'>{t('congratulation')}</p>
                                    <p className='p2'>APENFT {t('genesis')} NFT </p>
                                    <div className='div3'>
                                        <strong className='float-left'>#{tokenID}</strong>
                                        <strong className='float-right'>{t(RANKENUM[account.rank])}</strong>
                                    </div>
                                    <p className='p4'>
                                        <i className="fas fa-globe"></i>
                                        <a className='mx-6 hover:text-lightBlue-600' target='_blank'
                                           href={TRONSCAN + '/#/contract/' + CONTRACT}>{CONTRACT}</a>
                                    </p>

                                    {hit && <p className='p5'>
                                        {t('hit_p1')} $ {amount} NFT {t('token')}
                                    </p>}

                                    {hit && <p className='p6'>
                                        {t('hit_p2')}
                                    </p>}
                                </div>
                            }
                            {
                                halfDone && <p>{hash}</p>
                            }
                            {
                                (!loading && !done) &&
                                <button className='focus:outline-none' onClick={draw}>{t('click_draw')}</button>
                            }

                            {
                                loading &&
                                <img className='loading_img' src={require('../assets/img/loading.svg').default}/>
                            }

                        </div>
                    </div>

                </div>
            </div>


        </>
    );
}
